import React from "react";

/**
 * Browsers fill thick text strokes by nonzero winding, so where strokes of overlapping glyph contours cancel out
 * (accent vs. letter, letter counters), holes appear in the stroke underlayer (imagick doesn't do it).
 * The filter fills them by morphological closing (dilate + erode), which keeps the outer shape of the stroke.
 */

let filterCounter = 0

// unique per component instance, the filter region depends on the layer size
export const getStrokeUnderlayerFilterId = (): string => `text-stroke-underlayer-${++filterCounter}`

const getClosingRadius = (strokeWidth: number): number => strokeWidth ? Math.round(strokeWidth / 6) : 0

export const strokeUnderlayerFilterUrl = (id: string, strokeWidth: number): string | undefined =>
    getClosingRadius(strokeWidth) > 0 ? `url(#${id})` : undefined

interface Props {
    id: string
    strokeWidth: number
    box?: { x: number, y: number, width: number, height: number }  // layer center and size in user space of the text, without it the text bounding box is used
}

const StrokeUnderlayerFilter = ({ id, strokeWidth, box }: Props) => {
    const radius = getClosingRadius(strokeWidth)
    if (radius <= 0) {
        return null
    }

    // the region has to contain the whole stroke, otherwise the erode would cut the edges
    const region = box ? {
        filterUnits: 'userSpaceOnUse',
        x: box.x - .5 * box.width - 2 * strokeWidth,
        y: box.y - .5 * box.height - 2 * strokeWidth,
        width: 2 * box.width + 4 * strokeWidth,
        height: 2 * box.height + 4 * strokeWidth,
    } : {
        x: '-100%',
        y: '-100%',
        width: '300%',
        height: '300%',
    }

    return <defs>
        <filter id={id} {...region}>
            <feMorphology operator="dilate" radius={radius} />
            <feMorphology operator="erode" radius={radius} />
        </filter>
    </defs>
}

export default StrokeUnderlayerFilter
